export enum DismissType {
  close = 'close',
  back = 'back',
}
